@if (items.length) {
  @for (item of items; track $index) {
    <div
      class="flex gap-2 align-items-center border-top-1 surface-border w-full p-2">
      @switch (listType) {
        @case ('indicators') {
          <i
            [class]="
              item.isSet ? 'fas fa-ruler-combined' : 'fas fa-ruler-vertical'
            "></i>
          <span>{{ item.name }}</span>
          <span class="ml-auto flex gap-2 align-items-center">
            @if (dataStore.indicatorHasData(item._id)) {
              <p-chip
                styleClass="text-xs"
                label="Daten vorhanden"
                icon="fas fa-database" />
            }
            <app-indicator-detail-button class="ml-auto" [indicator]="item" />
          </span>
        }

        @case ('categories') {
          @if (
            indicatorStore.getByCategoryId(item._id);
            as categoryIndicators
          ) {
            <p-panel
              class="block w-full"
              styleClass="panel-minimal"
              [toggleable]="true"
              [collapsed]="true">
              <ng-template pTemplate="header">
                <div class="flex gap-2 align-items-center">
                  <i class="fas fa-folder"></i> <span>{{ item.name }}</span>
                  <p-badge
                    [value]="categoryIndicators.length"
                    class="ml-auto" />
                </div>
              </ng-template>
              <ul class="icon-list pl-0 align-items-baseline">
                @for (indicator of categoryIndicators; track $index) {
                  <li class="w-full gap-3">
                    <i class="fas fa-ruler-vertical"></i>
                    <span>{{ indicatorStore.getFullName(indicator) }}</span>
                    <span class="ml-auto flex gap-2 align-items-center">
                      @if (dataStore.indicatorHasData(indicator._id)) {
                        <p-chip
                          styleClass="text-xs"
                          label="Daten vorhanden"
                          icon="fas fa-database" />
                      }
                      <app-indicator-detail-button [indicator]="indicator" />
                    </span>
                  </li>
                }
              </ul>
            </p-panel>
          } @else {
            <div class="py-1 flex align-items-center gap-2">
              <i class="fas fa-folder"></i>
              <span>{{ item.name }}</span>
            </div>
          }
        }

        @case ('dataLayers') {
          @if (dataLayerTypeStore.getById(item.parent); as dataLayerType) {
            <app-data-layer-type-icon [dataLayerType]="dataLayerType" />
            <strong>{{ dataLayerType.name }}:</strong>
            <i class="ml-3 fas fa-calendar-days"></i>
            <span>{{ item.year }}</span>
            <span class="ml-auto flex gap-2 align-items-center">
              @if (dataStore.dataLayerHasData(item._id)) {
                <p-chip
                  styleClass="text-xs"
                  label="Daten vorhanden"
                  icon="fas fa-database" />
              }
            </span>
          }
        }

        @case ('tags') {
          <i class="fas fa-tag"></i>
          <span>{{ item.title }}</span>
        }

        @case ('indicatorData') {
          <i class="fas fa-database"></i>
          @if (dataLayerStore.getById(item.dataLayer); as dataLayer) {
            @if (indicatorStore.getById(item.indicator); as indicator) {
              <span
                >{{ indicatorStore.getFullName(indicator) }}
                {{ dataLayer.year }}</span
              >
            }
          }
        }
      }
    </div>
  }
}
